/*验证服务*/
define('services/mysetting/form.validate.service',['app'], function (app) {
    return app.factory('formValidateService', function () {

        function validateForm(form, specialItem) {
            if (specialItem) {
                angular.element("[name='" + specialItem + "']").focus();
                return;
            }
            var invalidNameArr = [];  // 验证不通过元素名称
            var invalidNumArr = [];  // 验证不通过元素距离页面顶部的距离
            for (var key in form) {
                //只遍历对象自身的属性，而不包含继承于原型链上的属性。Object.prototype.hasOwnProperty.call
                if (Object.prototype.hasOwnProperty.call(form,key) === true && key.indexOf('$') < 0) {
                    // form[key].$invalid == false 表示验证通过
                    if (form[key].$invalid && key != 'bankCNCity') {
                        form[key].$dirty = true;
                        var name = form[key].$name;
                        invalidNameArr.push(name);
                        invalidNumArr.push(angular.element("[name='" + name + "']").offset().top);
                    }
                }
            }
            var minNum = Math.min.apply(null, invalidNumArr);
            for (var i in invalidNumArr) {
                if (invalidNumArr[i] === minNum) {
                    if(invalidNameArr[i] != 'taxCity' && invalidNameArr[i] !='invoiceProvince'){
                        angular.element("[name='" + invalidNameArr[i] + "']").focus();
                    }
                }
            }
        }
        
        function hiddenInfo(str,frontLen,endLen) {   
          	 if(str.length <= (frontLen+endLen)){
          		 return str;
          	 }
  	         var len = str.length-frontLen-endLen;
  	         var xing = '';
  	         for (var i=0;i<len;i++) {
  	        	 xing+='*';
  	        }
  	        return str.substring(0,frontLen)+xing+str.substring(str.length-endLen);
       }
        
        function testBankAccout(bankAccout){
        	var regex = /^[a-zA-Z0-9\u4e00-\u9fa5（）()《》.]+$/;
        	return  regex.test(bankAccout);
        }
        
        function testPerCtfCode(perCtfCode){
        	var regex = /(^\d{15}$)|(^\d{17}([0-9]|X|x)$)/;
        	return  regex.test(perCtfCode);
        }


        return {
            'validateForm': validateForm,
            'hiddenInfo':hiddenInfo,
            'testBankAccout':testBankAccout,
            'testPerCtfCode':testPerCtfCode
        }
    });
});


